interface BlogSEO {
  title: string;
  description: string;
  keywords: string;
}

export const createBlogSEO = (
  title: string,
  description: string,
  keywords: string[]
): BlogSEO => {
  // Ensure title is not too long (max 60 chars including "| MdbApp")
  const maxTitleLength = 50; // Leaves room for "| MdbApp"
  const truncatedTitle = title.length > maxTitleLength 
    ? title.substring(0, maxTitleLength - 3) + "..."
    : title;

  // Ensure description is concise (max 155 chars)
  const maxDescLength = 155;
  const truncatedDesc = description.length > maxDescLength
    ? description.substring(0, maxDescLength - 3) + "..."
    : description;

  return {
    title: truncatedTitle,
    description: truncatedDesc,
    keywords: keywords.join(", ")
  };
};
